import PaymentForm from './PaymentForm';
import { useSelector } from 'react-redux';
import StripeElements from '@/Providers/StripeElements';

export default function Checkout({
    updateCard,
    selectedCard,
    label = null,
    error = false,
}) {
    const directQuote = useSelector((state) => state.directQuote);
    const country = directQuote?.quote?.country ?? 'GB';

    return (
        <>
            <div className="direct-quote__checkout">
                <>
                    <StripeElements countryCode={country}>
                        <PaymentForm
                            updateCard={updateCard}
                            selectedCard={selectedCard}
                            label={label}
                            formError={error}
                        />
                    </StripeElements>
                </>
            </div>
        </>
    );
}
